// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileDoneOutlinedSvg from "@fishx/icons-svg/es/asn/FileDoneOutlined";
import FishxIcon from '../components/FishxIcon';

var FileDoneOutlined = function FileDoneOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileDoneOutlinedSvg
  }));
};

FileDoneOutlined.displayName = 'FileDoneOutlined';
export default React.forwardRef(FileDoneOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileDoneOutlined.js
// module id = 2692
// module chunks = 0